import React from 'react';
import { Modal, Input, Tooltip, Spin } from "antd";
import { signUpApi, loginApi, resetApi, setPassword, verifySignUpApi } from './utils/ApiUtils';
import { COLORS } from './utils/Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faQuestionCircle, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import { writeEventToDb } from './utils/ApiUtils';

let inputHeight = 41, borderRadius = 20;

export default class LoginModal extends React.Component {
  
  state = { visible: true, modalState: this.props.modalNumber, signupText: '', loginEmail: '', loginText: '', forgotEmail: '',
  password: '', confirmPassword: '', forgotPassText: '', resetText: 'Please enter password to complete Signup process',
  loader: false };
  componentDidMount() {
    let windowUrl = window.location.href;
    if((windowUrl.includes('/signup-invite/')||windowUrl.includes('/reset-password-invite/'))&&(this.state.modalState===3)) {
      const words = windowUrl.split('/');
      let token = words[words.length-1];
      this.setState({ emailToken: token });  
      if(windowUrl.includes('/reset-password-invite/')) {
        this.setState({ resetText: 'Set your new password below' });
      }
      console.log('emailToken='+token);
      verifySignUpApi(token)
      .then(response => {
        console.log('got verify SignUp Api='+JSON.stringify(response));
        if(!response.ok) {
          this.setState({ modalState: 1, loginText: response.info ? response.info : 'Link expired. Please try again.' });  
        }
        let apiMessage = response.ok ? 'Login Success' : response.info;
        this.writeNonUserEvent('verifySignupEvent', response.ok, apiMessage, token);
      })
      .catch((error) => {
        console.log('Error getting login'+JSON.stringify(error));
        this.setState({ modalState: 1, loginText: 'Link expired. Please try again.' });
      });
    }
  }
  writeNonUserEvent = (eventName, apiStatus, apiMessage, emailToken) => {
    let basicInfo = this.props.basicInfo;
    let analyticsObj = { ...basicInfo, eventName: eventName, apiStatus: apiStatus, apiMessage: apiMessage,
      emailToken: emailToken, timeStamp: Date.now() };
    let updates = { };
    updates[this.props.uniqueId] = analyticsObj;
    console.log('eventName='+eventName+' updates='+JSON.stringify(updates));
    writeEventToDb(updates);
  }
  setModalVisible(visible) {
    this.setState({ visible: visible });
    console.log('props='+this.props);
    this.props.setVisibility(false);
  }
  setModalState(visible) {
    this.setState({ modalState: visible });
  }
  onChangeEmail = e => {
    console.log('loginEmail='+e.target.value);
    this.setState({ loginEmail: e.target.value });
  }
  onChangeSignUpEmail = e => {
    console.log('signupEmail='+e.target.value);
    this.setState({ signupEmail: e.target.value });
  }
  onChangeForgotEmail = e => {
    console.log('forgotemail='+e.target.value);
    this.setState({ forgotEmail: e.target.value });
  }
  onChangePassword = e => {
    console.log('password='+e.target.value);
    this.setState({ password: e.target.value });
  }
  onChangePass = e => {
    console.log('password='+e.target.value);
    this.setState({ password: e.target.value });
  }
  onChangeConfirmPass = e => {
      console.log('confirm pass='+e.target.value);
      this.setState({ confirmPassword: e.target.value });
  }
  callForgotPassword = () => {
    let forgotEmail = this.state.forgotEmail;
    console.log('forgotEmail='+forgotEmail);
    if(!(forgotEmail)) {
      this.setState({ forgotPassText: 'Email cannot be empty.' });
      return;
    }
    if(this.state.loader) {
      return;
    }
    this.setState({ loader: true });
    resetApi(forgotEmail)
    .then(response => {
      console.log('got login='+JSON.stringify(response));
      if(response.ok) {
        this.setState({ forgotPassText: response.info.response ? response.info.response : 'Reset password failed. Please try again.' });
      } else {
        this.setState({ forgotPassText: response.info ? response.info : 'Reset password failed. Please try again.' });  
      }
      let apiMessage = response.ok ? 'Login Success' : response.info;
      this.writeNonUserEvent('resetPasswordEvent', response.ok, apiMessage, forgotEmail);
      this.setState({ loader: false });
    })
    .catch((error) => {
      console.log('Error getting login'+JSON.stringify(error));
      this.setState({ loader: false, forgotPassText: 'Reset password failed. Please try again.' });
    });
  }
  callResetPassword = () => {
    let token = this.state.emailToken;
    let pass1 = this.state.password;
    let pass2 = this.state.confirmPassword;
    if(pass1!==pass2) {
      this.setState({ resetText: 'Passwords do not match!' });
      return;
    }
    if(this.state.loader) {
      return;
    }
    console.log('token='+token);
    this.setState({ loader: true });
    setPassword(token, pass1, pass2)
    .then(response => {
      console.log('got login='+JSON.stringify(response));
      if(response.ok) {
        this.setState({ password: '', confirmPassword: '', modalState: 1, 
        loginText: response.info.response ? response.info.response : (response.info ? response.info : 'Password updated. Please login.') });
      } else {
        this.setState({ resetText: response.info.response ? response.info.response : (response.info ? response.info : 'Password set failed!') });
      }
      this.setState({ loader: false });
      let apiMessage = response.ok ? 'Login Success' : response.info;
      this.writeNonUserEvent('setPasswordEvent', response.ok, apiMessage, token);
    })
    .catch((error) => {
      console.log('Error getting login'+JSON.stringify(error));
      this.setState({ loader: false, resetText: 'Password set failed!' });
    });
}
  callSignUp = () => {
    let signupEmail = this.state.signupEmail, ip = "49.206.32.54";
    console.log('signupEmail='+signupEmail);
    if(!(signupEmail)) {
      this.setState({ signupText: 'Email cannot be empty.' });
      return;
    }
    if(this.state.loader) {
      return;
    }
    this.setState({ loader: true });
    signUpApi(signupEmail, ip)
    .then(response => {
      console.log('got sign up='+JSON.stringify(response));
      if(response.ok) {
        this.setState({ signupText: response.info.response });
      } else {
        this.setState({ signupText: response.info ? response.info : 'Signup failed. Please try again.' });  
      }
      this.setState({ loader: false });
      let apiMessage = response.ok ? 'Login Success' : response.info;
      this.writeNonUserEvent('signUpEvent', response.ok, apiMessage, signupEmail);
    })
    .catch((error) => {
      console.log('Error getting login'+JSON.stringify(error));
      this.setState({ loader: false, signupText: 'Signup failed. Please try again.' });
    });
  }
  callLogin = () => {
    let loginEmail = this.state.loginEmail, password = this.state.password;
    console.log('loginEmail='+loginEmail);
    if(!(loginEmail&&password)) {
      this.setState({ loginText: 'Email/password cannot be empty.' });
      return;
    }
    if(this.state.loader) {
      return;
    }
    this.setState({ loader: true });
    loginApi(loginEmail, password)
    .then(response => {
      console.log('got login='+(response));
      if(response.ok) {
        // this.setState({ loginText: response.info });
        this.props.setLogin();
      } else {
        this.setState({ loginText: response.info ? response.info : 'Login failed. Please try again.' });  
      }
      this.setState({ loader: false });
      let apiMessage = response.ok ? 'Login Success' : response.info;
      this.writeNonUserEvent('loginEvent', response.ok, apiMessage, loginEmail);
    })
    .catch((error) => {
      console.log('Error getting login'+JSON.stringify(error));
      this.setState({ loader: false, loginText: 'Login failed. Please try again.' });  
    });
  }
  submitClick = () => {
    let modalState = this.state.modalState;
    switch(modalState) {
      case 2:
        this.callSignUp();
        break;
      case 3:
        this.callResetPassword();
        break;
      case 4:
        this.callForgotPassword();
        break;
      default:
        this.callLogin();
        break;
    }
  }
  loginUI = () => {
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <div style={{ height: '30%', display: 'flex', justifyContent: 'center' }}>
          <h4 style={{ color: COLORS.yellow, textAlign:'center', alignSelf: 'center', fontFamily: 'OpenSans-SemiBold' }}>{this.state.loginText}</h4>
        </div>
        <div style={{ height: '40%' }}>
          <Input onPressEnter={() => { this.submitClick() }} size='large' className="loginInput" onChange={this.onChangeEmail} value={this.state.loginEmail} placeholder="Email" 
          style={{ marginBottom: 12, fontFamily: 'OpenSans-Bold', height: inputHeight, borderRadius: borderRadius }} />
          <Input onPressEnter={() => { this.submitClick() }} size='large' className="loginInput" type="password"
            style={{ fontFamily: 'OpenSans-Bold', height: inputHeight, borderRadius: borderRadius }}
            onChange={this.onChangePassword} 
            placeholder="Password" value={this.state.password} 
            suffix={<Tooltip title="Forgot Password?">
              <FontAwesomeIcon color={COLORS.yellow} icon={faQuestionCircle} style={{ fontSize: 22, cursor: 'pointer' }}
              onClick={() => { this.setModalState(4) }} />
            </Tooltip>} 
          />
        </div>
        <div style={{ display:'flex', justifyContent:'center', alignContent:'center', height: '30%' }}>
          <div style={{ justifyContent:'center' }}>
            <p style={{ margin: 0, color: COLORS.cccWhite, fontFamily: 'OpenSans-SemiBold' }}>By using Hit.Movie you agree to these 
              <a target='_blank' rel="noopener noreferrer" className='serviceLink' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', fontFamily: 'OpenSans-SemiBold' }} href="https://docs.hit.movie/services-and-privacy-terms">
                Service and Privacy Terms
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }
  signupUI = () => {
    return (
      <div style={{ width: '100%', height: '100%' }}>
          <div style={{ height: '30%', display: 'flex', justifyContent: 'center' }}>
            <h4 style={{ color: COLORS.yellow, textAlign:'center', alignSelf: 'flex-end', fontFamily: 'OpenSans-SemiBold' }}>{this.state.signupText}</h4>
          </div>
          <div style={{ height: '40%' }}>
            <Input onPressEnter={() => { this.submitClick() }} size='large' className="loginInput" placeholder="Email" onChange={this.onChangeSignUpEmail} 
              style={{ marginTop:'15%', fontFamily: 'OpenSans-Bold', height: inputHeight, borderRadius: borderRadius }} />
          </div>
          <div style={{ display:'flex', justifyContent:'center', alignContent:'center', height: '30%' }}>
            <div style={{ justifyContent:'center' }}>
              <p style={{ margin: 0, color: COLORS.cccWhite, fontFamily: 'OpenSans-SemiBold' }}>By using Hit.Movie you agree to these 
                <a target='_blank' rel="noopener noreferrer" className='serviceLink' style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', fontFamily: 'OpenSans-SemiBold' }} href="https://docs.hit.movie/services-and-privacy-terms">
                  Service and Privacy Terms
                </a>
              </p>
            </div>
          </div>
      </div>
    );
  }
  resetPassword = () => {
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <div style={{ height: '30%', display: 'flex', justifyContent: 'center' }}>
          <h4 style={{ color: COLORS.yellow, textAlign:'center', alignSelf: 'flex-end', fontFamily: 'OpenSans-SemiBold' }}>
          {this.state.resetText}
          </h4>
        </div>
        <div style={{ height: '40%', marginTop:'15%' }}>
          <Input type="password" size='large' className="loginInput" onChange={this.onChangePass} placeholder="New Password" 
          style={{ fontFamily: 'OpenSans-Bold', height: inputHeight, borderRadius: borderRadius, marginBottom: 12 }} />
          <Input type="password" size='large' className="loginInput" onChange={this.onChangeConfirmPass} placeholder="Re-enter Password" 
          style={{ fontFamily: 'OpenSans-Bold', height: inputHeight, borderRadius: borderRadius }} />
        </div>
      </div>
    );
  }
  forgotPassword = () => {
    return (
      <div style={{ width: '100%', height: '100%' }}>
          <div style={{ height: '30%', display: 'flex', justifyContent: 'center' }}>
            <h4 style={{ color: COLORS.yellow, textAlign:'center', alignSelf: 'flex-end', fontFamily: 'OpenSans-SemiBold' }}>{this.state.forgotPassText}</h4>
          </div>
          <div style={{ height: '40%' }}>
            <Input size='large' className="loginInput" placeholder="Email" onChange={this.onChangeForgotEmail} 
              style={{ marginTop:'15%', fontFamily: 'OpenSans-Bold', height: inputHeight, borderRadius: borderRadius }} 
              suffix={<FontAwesomeIcon color={COLORS.yellow} icon={faArrowLeft} style={{ fontSize: 22, cursor: 'pointer' }}
              onClick={() => { this.setModalState(1) }} />}  />
          </div>
      </div>
    );
  }
  render() {
    let modalState = this.state.modalState;
    let middleUI = null;
    let resetTitleText = '';
    switch(modalState) {
      case 2:
        middleUI = this.signupUI();
        break;
      case 3:
        middleUI = this.resetPassword();
        resetTitleText = 'Set Password';
        if(window.location.href.includes('/reset-password-invite/')) {
          resetTitleText = 'Reset Password';
        }
        break;
      case 4:
        middleUI = this.forgotPassword();
        resetTitleText = 'Forgot Password';
        break;
      default:
        middleUI = this.loginUI();
        break;
    }
    let isMobile = window.innerWidth<768;
    return (
      <Modal
        width={320}
        closable={false}
        centered={isMobile ? true : false}
        bodyStyle={{ top: isMobile ? '10%' : '0%', height: 420, padding: 0, backgroundColor: COLORS.white }}
        visible={this.state.visible}
        onOk={() => this.setModalVisible(false)}
        onCancel={() => this.setModalVisible(false)}
        footer={null}
      >
        <div style={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column', padding: 4, backgroundColor: COLORS.yellow }}>
          <div style={{ display: 'flex', justifyContent:'center', height: '18%', backgroundColor: COLORS.blue2a3a4a }}>
            { modalState<3
            ?
            <div style={{ display: 'flex', justifyContent:'center', height: '100%', width: '100%' }}>
              <div onClick={() => this.setModalState(1)} style={{ flex:1, width: '100%', height: '100%', cursor: 'pointer', display: 'flex' }}>
                <div style={{ flex:1, textAlign: 'center', alignSelf: 'center', margin: 0, fontSize: 20, color: modalState===1 ? COLORS.yellow : COLORS.lightBlue, fontFamily: 'OpenSans-Bold' }} >
                  Login
                </div>
              </div>
              <div style={{ width: 0, height: '100%', backgroundColor: COLORS.yellow }} />
              <div onClick={() => this.setModalState(2)} style={{ flex:1, width: '100%', height: '100%', cursor: 'pointer', display: 'flex' }}>
                <div style={{ flex:1, textAlign: 'center', alignSelf: 'center', margin: 0, fontSize: 20, color: modalState===2 ? COLORS.yellow : COLORS.lightBlue, fontFamily: 'OpenSans-Bold' }} >
                  Signup
                </div>
              </div>
            </div>
            :
            <div style={{ display: 'flex', justifyContent:'center', height: '100%', width: '100%' }}>
              <div style={{ flex:1, textAlign: 'center', alignSelf: 'center', margin: 0, fontSize: 20, color: COLORS.yellow, fontFamily: 'OpenSans-Bold' }} >
                {resetTitleText}
              </div>
            </div>
            }
          </div>
          <div style={{ width:'100%', height: 0, backgroundColor: COLORS.yellow }} />
          <div style={{ height: '65%', paddingLeft: 24, paddingRight: 24, backgroundColor: COLORS.lightBlue }}>
            {middleUI}
          </div>
          <div style={{ width:'100%', height: 0, backgroundColor: COLORS.yellow }} />
          <div style={{ display: 'flex', justifyContent:'center', alignContent:'center', height: '17%', backgroundColor: COLORS.blue2a3a4a }}>
            <div style={{ flex:1, alignSelf:'center', textAlign:'center', marginLeft: 20 }}>
                <FontAwesomeIcon className='loginSubmit' icon={faTimes} onClick={() => this.setModalVisible(false)} 
                style={{ cursor: 'pointer', fontSize: 34 }} />
            </div>
            <div style={{ flex:1, alignSelf:'center', textAlign: 'center', marginRight: 20 }}>
              <FontAwesomeIcon className='loginSubmit' icon={faCheck} onClick={() => this.submitClick()} 
               style={{ cursor: 'pointer', fontSize: 34 }} />
              { this.state.loader &&
                <div style={{ position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center', right: 20, bottom: 28 }}>
                <Spin size='small' style={{  }} />
                </div>
              }
            </div>
          </div>
        </div>
      </Modal>
  );
  }
}